export function parseInvoiceDate(value: string): Date | null {
    if (!value) {
        return null;
    }

    const parsed = new Date(`${value}T00:00:00.000Z`);
    return isNaN(parsed.getTime()) ? null : parsed;
}

export interface IInvoiceDateRange {
    from: Date | null;
    to: Date | null;
}

export function getRangeForInvoiceDate(value: string): IInvoiceDateRange {
    const parsed = parseInvoiceDate(value);
    return { from: parsed, to: parsed };
}

export interface IDefaultInvoiceDateSelection extends IInvoiceDateRange {
    selectedInvoiceDate: string;
}

export function getDefaultInvoiceDateSelection(dates: string[]): IDefaultInvoiceDateSelection | null {
    if (!dates || dates.length === 0) {
        return null;
    }

    const latestInvoiceDate = dates[0];
    return { selectedInvoiceDate: latestInvoiceDate, ...getRangeForInvoiceDate(latestInvoiceDate) };
}
